import { forwardRef } from 'react'

import Button, { type ButtonProps } from '..'

type RoundButtonSmallProps = Omit<ButtonProps, 'appearance' | 'fixedAspectRatio' | 'iconSize' | 'roundness' | 'size'>

const RoundButtonSmall = forwardRef<ButtonProps, RoundButtonSmallProps>(({ ...props }) => {
  return <Button appearance="bordered" fixedAspectRatio iconSize={16} roundness="full" size={34} {...props} />
})

RoundButtonSmall.displayName = 'RoundButtonSmall'

export default RoundButtonSmall
